
<template>
  <nav id="menu">      
      <a href="#" v-if="options.navicon" @click="openGroupPersistance">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66666 10H25.3333M6.66666 16H25.3333M6.66666 22H25.3333" stroke="black" stroke-miterlimit="10" stroke-linecap="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.close" @click="closeGroupPersistance">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" />
            <path d="M25 7L7 25M25 25L7 7L25 25Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.back" @click="back">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.2499 25L6.24994 16L15.2499 7M7.49994 16H25.7499" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.crossGroups" @click="crossGroups">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" />
            <path d="M24 18.9091V24H18.9091M23.5364 23.535L18.1818 18.1818M8 13.0909V8H13.0909M8.46364 8.465L13.8182 13.8182M18.9091 8H24V13.0909M23.535 8.46364L18.1818 13.8182M13.0909 24H8V18.9091M8.465 23.5364L13.8182 18.1818" stroke="#000000" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.remix" @click="remixGroups">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" />
            <path d="M19.2 8C19.2 8 18 8 16 8C14.4178 8 12.871 8.46919 11.5554 9.34824C10.2398 10.2273 9.21447 11.4767 8.60897 12.9385C8.00347 14.4003 7.84504 16.0089 8.15372 17.5607C8.4624 19.1126 9.22433 20.538 10.3431 21.6569C11.462 22.7757 12.8874 23.5376 14.4393 23.8463C15.9911 24.155 17.5997 23.9965 19.0615 23.391C20.5233 22.7855 21.7727 21.7602 22.6518 20.4446C23.5308 19.129 24 17.5822 24 16" stroke="black" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M17.5 5.35001L20.1667 8.01667L17.5 10.6833" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a href="#" v-if="options.screenshot" @click="screenshot">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" />
            <circle cx="16" cy="16" r="9.6" stroke="black" stroke-width="0.8"/>
            <line x1="6.93652" y1="12.2249" x2="18.1865" y2="12.2249" stroke="black" stroke-width="0.8"/>
            <line x1="13.8125" y1="19.475" x2="25.0625" y2="19.475" stroke="black" stroke-width="0.8"/>
            <line x1="14.5964" y1="6.1125" x2="20.2214" y2="15.8553" stroke="black" stroke-width="0.8"/>
            <line x1="11.9714" y1="15.925" x2="17.5964" y2="25.6678" stroke="black" stroke-width="0.8"/>
            <line x1="23.7839" y1="9.95" x2="18.1589" y2="19.6928" stroke="black" stroke-width="0.8"/>
            <line x1="14.1589" y1="12.45" x2="8.53391" y2="22.1928" stroke="black" stroke-width="0.8"/>
        </svg>
      </a>
      <!--
      <a href="#" v-if="options.share">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="4" fill="none"/>
        <path d="M11 18C12.1046 18 13 17.1046 13 16C13 14.8954 12.1046 14 11 14C9.89543 14 9 14.8954 9 16C9 17.1046 9.89543 18 11 18Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 12C22.1046 12 23 11.1046 23 10C23 8.89543 22.1046 8 21 8C19.8954 8 19 8.89543 19 10C19 11.1046 19.8954 12 21 12Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 24C22.1046 24 23 23.1046 23 22C23 20.8954 22.1046 20 21 20C19.8954 20 19 20.8954 19 22C19 23.1046 19.8954 24 21 24Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 11L13 15.0234M13 16.9766L19 21L13 16.9766Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      -->
  </nav>
</template>

<script>

export default {
    name: 'Menu',
    computed: {
      options(){
        return this.$store.state.UIstate.menuOptions;
      }
    },
    methods: {
      openGroupPersistance(){
        this.$store.commit('configMenuUI', { close: true, navicon: false });
        this.$store.commit('toggleGroupPersistance');
      },
      closeGroupPersistance(){
        this.$store.commit('configMenuUI', { close: false, navicon: true });
        this.$store.commit('toggleGroupPersistance');
      },
      back(){
        this.$router.push('/');
      },
      crossGroups(){
        this.$store.dispatch('createCrossGroups');
      },
      remixGroups(){
        this.$store.dispatch('remixGroups');
      },
      screenshot(){
        this.$emit('screenshot')
      }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';

$base: 2.4rem;

#menu {
    position: fixed;
    top: 1.5rem;
    left: 1.5rem;
    background: white;
    box-shadow: 0 0 .5rem rgba($color: #000000, $alpha: .2);
    display: flex;
    flex-direction: column;
    padding: .5rem;
    gap: .5rem;
    border-radius: .25rem;
    z-index: 9999;

    > a {
        padding: 0;
        @include center;
        height: $base;
        width: $base;
        border-radius: .25rem;
        background: #EEE;
        transition: all .2s ease;

        svg {
//            transform: rotateZ(0);
//            transition: all .2s ease-out;
        }

        &:hover {
            background: #222;

            svg {
                //transform: rotateZ(180deg);

                path, line, circle {
                    stroke: #eee;
                }
            }

        }
    }

}
</style>